// removed by extract-text-webpack-plugin
module.exports = {"sidebarContainer":"sidebarContainer-2CD0c","sidebarContent":"sidebarContent-1tfND","sidebarCTA":"sidebarCTA-1eUuV","sidebarImageGrid":"sidebarImageGrid-3AiJS","sidebarImageItem":"sidebarImageItem-zKuPQ","sidebarImage":"sidebarImage-3GNRE","csvDownloadLink":"csvDownloadLink-ogEgk","buttonLink":"buttonLink-39a55"};


//////////////////
// WEBPACK FOOTER
// ./src/components/sidebar/_sidebarWidget.css
// module id = 239
// module chunks = 1